export const messagesSSID = {
    pt: {
        message:{
            registerSSIDTitle: `Registro SSID's`,
            registerSSID: 'Cadastrar novo SSID',
            editSSID: 'Editar SSID',
            deleteSSID: 'Deletar SSID',
            deleteSSIDConfirmation: 'Você tem certeza que deseja remover esse SSID?',
            newSSID: 'Novo SSID',
            removeSuccessMessage: 'SSID removido com sucesso',
            editSuccessMessage: 'SSID atualizado com sucesso'
        }
    },
    es: {
        message:{
            registerSSIDTitle: `Registrar SSID's`,
            registerSSID: 'Cadastrar nuevo SSID',
            editSSID: 'Editar SSID',
            deleteSSID: 'Eliminar SSID',
            deleteSSIDConfirmation: '¿Estás seguro de que deseas eliminar este SSID?',
            newSSID: 'Nuevo SSID',
            removeSuccessMessage: 'SSID eliminado con éxito',
            editSuccessMessage: 'SSID actualizado exitosamente'
        }
    },
    en: {
        message:{
            registerSSIDTitle: `SSID's Register`,
            registerSSID: 'Register new SSID',
            editSSID: 'Edit SSID',
            deleteSSID: 'Delete SSID',
            deleteSSIDConfirmation: 'Are you sure you want to remove this SSID',
            newSSID: 'New SSID',
            removeSuccessMessage: 'SSID removed successfully',
            editSuccessMessage: 'SSID updated successfully'
        }
    }
}
